import { skillById } from './professions';

/** Canonical skill IDs also name the generated, class-specific icon files. */
export function classSkillIcon(id: string): string | undefined {
  return skillById(id) ? `/assets/characters/r15/icons/${id}.webp` : undefined;
}
